"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Thiana API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSecretaryInput = instanceOfSecretaryInput;
exports.SecretaryInputFromJSON = SecretaryInputFromJSON;
exports.SecretaryInputFromJSONTyped = SecretaryInputFromJSONTyped;
exports.SecretaryInputToJSON = SecretaryInputToJSON;
/**
 * Check if a given object implements the SecretaryInput interface.
 */
function instanceOfSecretaryInput(value) {
    if (!('professional_id' in value) || value['professional_id'] === undefined)
        return false;
    return true;
}
function SecretaryInputFromJSON(json) {
    return SecretaryInputFromJSONTyped(json, false);
}
function SecretaryInputFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'professional_id': json['professional_id'],
    };
}
function SecretaryInputToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'professional_id': value['professional_id'],
    };
}
